import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';
import {
  BsTelephoneFill,
  BsWhatsapp,
  BsEnvelopeFill,
  BsGeoAltFill,
} from "react-icons/bs";

function Navimumbaiairporttogoacab() {



const cardData = {
  keyword: " Navi Mumbai Airport to Goa Cabs",

headingDescription:
  "Omshree Cab offers reliable and comfortable Navi Mumbai Airport to Goa cab services for travelers planning a scenic and memorable road trip to one of India’s most popular beach destinations. Goa is known for its pristine beaches, vibrant nightlife, Portuguese heritage, spice plantations, and coastal cuisine, making it a favorite destination for families, couples, friends, and solo travelers. Whether you are arriving at Navi Mumbai International Airport for a vacation, honeymoon, or group getaway, our cab service ensures a smooth and safe journey with experienced drivers and well‑maintained vehicles. The distance from Navi Mumbai Airport to Goa is approximately 580–620 km depending on the route, and the journey typically takes around 10–12 hours by road. We provide flexible booking options including one‑way transfers, round‑trip packages, and multi‑day travel plans with transparent pricing and no hidden charges. Our fleet includes air‑conditioned sedans, spacious SUVs, luxury cars, and tempo travelers suitable for solo travelers, families, and groups. With punctual airport pickups, professional chauffeurs familiar with long‑distance and highway routes, and 24/7 customer support, Omshree Cab is your trusted partner for Navi Mumbai Airport to Goa cab booking.",

topPlaces: [
  {
    title: "Baga Beach",
    description:
      "Baga Beach is one of Goa’s most popular and vibrant beaches, known for its lively atmosphere, water sports, and beachside shacks serving seafood and drinks. Visitors can enjoy activities like parasailing, jet skiing, and banana boat rides or simply relax on the sandy shores while watching the sunset. A cab ride from Navi Mumbai Airport to Goa allows travelers to start their beach holiday comfortably and conveniently at this energetic coastal destination."
  },
  {
    title: "Calangute Beach",
    description:
      "Calangute Beach, often called the ‘Queen of Beaches’ in Goa, is a must‑visit destination for tourists looking to experience the best of Goa’s coastline. The beach is lined with eateries, shacks, and shops offering local handicrafts. Visitors can swim, relax, enjoy sunbathing, and indulge in lively nightlife options nearby. Traveling by cab from Navi Mumbai Airport makes it easy to reach Calangute and explore the surrounding attractions at leisure."
  },
  {
    title: "Fort Aguada",
    description:
      "Fort Aguada is a historic Portuguese fort located overlooking the Arabian Sea and is famous for its well‑preserved lighthouse and panoramic coastal views. Built in the 17th century to guard against Dutch and Maratha invasions, the fort offers scenic views, heritage architecture, and walking paths. A comfortable cab journey from Navi Mumbai Airport to Goa allows tourists to visit this iconic heritage site and enjoy spectacular sea views."
  },
  {
    title: "Dudhsagar Waterfalls",
    description:
      "Dudhsagar Waterfalls is one of Goa’s most breathtaking natural attractions, especially spectacular during the monsoon season when water cascades down from great heights. Visitors can enjoy boat rides, jeep safaris, and nature treks to reach viewing points near the falls. A cab service from Navi Mumbai Airport allows travelers to plan their visit to this majestic waterfall along with other Goa sightseeing spots."
  },
  {
    title: "Anjuna Beach",
    description:
      "Anjuna Beach is famous for its bohemian vibe, vibrant flea markets, beach parties, and laid‑back ambiance. Visitors come here for sunbathing, relaxation, and exploring the local market where handmade goods, jewelry, and souvenirs are sold. A cab journey from Navi Mumbai Airport makes it convenient to reach this unique beach destination and enjoy its eclectic culture."
  },
  {
    title: "Basilica of Bom Jesus",
    description:
      "The Basilica of Bom Jesus in Old Goa is a UNESCO World Heritage Site and one of the most important historical churches in India. It houses the mortal remains of St. Francis Xavier and showcases magnificent Baroque architecture. Tourists and history enthusiasts visit to admire the art, design, and religious significance of this landmark. Traveling by cab provides a comfortable way to include this cultural attraction in your Goa itinerary."
  },
  {
    title: "Colva Beach",
    description:
      "Colva Beach, located in South Goa, is known for its long stretches of sand, calm waters, and picturesque sunsets. Visitors enjoy swimming, beach walks, and relaxation under palm trees. The area also offers restaurants and beach shacks serving local cuisine. Taking a cab from Navi Mumbai Airport to Goa allows travelers to reach this serene beach and enjoy a peaceful coastal experience."
  },
  {
    title: "Chapora Fort",
    description:
      "Chapora Fort offers stunning panoramic views of the Arabian Sea and the surrounding coastline. The fort became famous after being featured in popular Indian films. Visitors often enjoy photography, scenic walks, and sunset views from this elevated vantage point. A cab ride from Navi Mumbai Airport makes it easy to include this historic and scenic destination in your Goa sightseeing plans."
  },
  {
    title: "Palolem Beach",
    description:
      "Palolem Beach is a scenic crescent‑shaped beach in South Goa known for its calm waters, scenic beauty, and relaxed ambiance. Visitors come here for kayaking, dolphin spotting boat tours, and leisurely strolls along the shore. The peaceful surroundings make it ideal for couples and families seeking a quiet getaway. A cab journey from Navi Mumbai Airport allows tourists to comfortably reach this beautiful beach and enjoy the tranquil coastal setting."
  },
  {
    title: "Spice Plantations",
    description:
      "Goa’s spice plantations are rich gardens where visitors can learn about the cultivation of spices like black pepper, cardamom, cinnamon, and nutmeg. Guided tours showcase traditional farming methods, help guests experience local culture, and include tastings of Goan cuisine. Tourists traveling by cab from Navi Mumbai Airport can easily include a visit to these plantations as part of an enriching Goa vacation."
  }
],



services: [
{
name: "Navi Mumbai Airport to Goa Cab",
description: "Navi Mumbai Airport to Goa cab service provides comfortable long-distance travel for tourists and families planning a relaxing Goa trip. Travelers arriving at Navi Mumbai International Airport can directly book a cab for a smooth journey to Goa beaches and popular tourist destinations. Our vehicles include comfortable sedans, SUVs, and spacious MPV cars suitable for long highway travel. Professional drivers ensure safe driving and punctual airport pickups with luggage assistance. Passengers enjoy air-conditioned comfort, spacious seating, and reliable service throughout the journey. The cab service is perfect for holiday travelers, couples, and group tours heading to Goa. It offers a convenient and stress-free road trip from Navi Mumbai Airport to Goa."
},
{
name: "Navi Mumbai Airport to Goa Taxi",
description: "Navi Mumbai Airport to Goa taxi service offers reliable intercity transportation for travelers visiting Goa from the airport. The taxi provides comfortable seating and smooth highway performance for long journeys. Professional drivers ensure safe driving and timely pickups from airport terminals. The service is ideal for tourists, families, and group travelers heading to Goa beaches. Vehicles are well maintained with clean interiors and powerful AC cooling. Passengers enjoy relaxed travel with convenient pickup and drop services. The taxi service ensures dependable long-distance transportation."
},
{
name: "Cab from Navi Mumbai Airport to Goa",
description: "Cab from Navi Mumbai Airport to Goa provides convenient transportation for travelers arriving at the airport and planning a direct road trip to Goa. The vehicles offer comfortable seating and ample luggage space for long journeys. Professional drivers ensure safe highway driving and punctual pickup services from airport locations. The service is ideal for tourists and families traveling to Goa beaches and resorts. Comfortable interiors and smooth ride quality make the journey relaxing. Travelers enjoy convenient and reliable transportation services. The cab ensures a comfortable travel experience from Navi Mumbai Airport to Goa."
},
{
name: "Taxi from Navi Mumbai Airport to Goa",
description: "Taxi from Navi Mumbai Airport to Goa offers dependable road travel for passengers planning a Goa vacation directly from the airport. The taxi provides comfortable seating and efficient AC interiors suitable for long-distance journeys. Professional drivers ensure safe driving and timely airport pickup services. It is ideal for tourists traveling to Goa beaches, resorts, and sightseeing locations. Passengers enjoy smooth ride quality during the entire highway journey. The taxi service provides convenient transportation without travel stress. Travelers can enjoy a comfortable and reliable road trip."
},
{
name: "Navi Mumbai Airport Goa Cab Service",
description: "Navi Mumbai Airport Goa cab service provides reliable airport pickup transportation for travelers heading to Goa. Vehicles provide spacious seating and comfortable interiors suitable for long highway travel. Professional drivers ensure safe driving and timely pickups from airport terminals. Ideal for families, couples, and tourist groups visiting Goa. The cab service offers convenient travel planning with flexible scheduling options. Passengers enjoy comfortable AC travel and reliable service throughout the trip. It is a convenient travel option for Goa road journeys."
},
{
name: "Navi Mumbai Airport Goa Taxi Service",
description: "Navi Mumbai Airport Goa taxi service offers dependable long-distance taxi transportation for passengers traveling from Navi Mumbai Airport to Goa. The vehicles provide comfortable seating and smooth ride quality for extended journeys. Professional drivers ensure punctual pickup and safe driving throughout the route. Ideal for family holidays, beach tours, and group travel. Travelers enjoy comfortable interiors and reliable travel experience. The taxi service provides convenient airport-to-Goa transportation. Passengers can enjoy a relaxed and comfortable journey."
},
{
name: "Navi Mumbai Airport to Goa Cab Booking",
description: "Navi Mumbai Airport to Goa cab booking allows travelers to reserve vehicles easily for direct airport to Goa travel. Customers can book sedans, SUVs, or spacious MPV vehicles depending on group size and comfort requirements. Online and phone booking options provide quick confirmation for travelers. Professional drivers ensure punctual airport pickup services and safe highway travel. The service is ideal for tourists planning Goa beach vacations. Comfortable vehicles ensure relaxed long-distance travel. Passengers enjoy convenient and reliable cab reservations."
},
{
name: "Navi Mumbai Airport to Goa Taxi Booking Online",
description: "Navi Mumbai Airport to Goa taxi booking online provides convenient digital reservations for travelers planning Goa trips. Customers can easily book taxis online and receive instant booking confirmation. The vehicles provide comfortable seating and reliable highway performance. Professional drivers ensure punctual airport pickups and safe driving. The service is suitable for families, tourists, and business travelers. Online booking simplifies travel planning and saves time. Travelers enjoy hassle-free airport taxi reservations."
},
{
name: "Navi Mumbai Airport to Goa Cab Price",
description: "Navi Mumbai Airport to Goa cab price options provide transparent travel cost estimates depending on vehicle type and travel distance. Customers can choose from sedans, SUVs, or MPV vehicles according to group size and comfort needs. The service offers competitive pricing for long-distance travel. Travelers receive clear fare details before booking their trip. Professional drivers ensure safe driving and punctual pickup services. Comfortable vehicles ensure relaxed travel for passengers. Customers enjoy affordable and reliable transportation services."
},
{
name: "Navi Mumbai Airport to Goa Taxi Fare",
description: "Navi Mumbai Airport to Goa taxi fare services offer flexible pricing depending on vehicle category and travel duration. Travelers can choose economical sedans or spacious SUVs depending on travel needs. The taxi service provides transparent fare estimates for long-distance journeys. Professional drivers ensure safe and comfortable travel throughout the route. The vehicles provide air-conditioned comfort and ample luggage space. Families and tourists enjoy smooth highway travel experiences. The service offers dependable and affordable transportation."
},
{
name: "Navi Mumbai Airport to Goa One Way Cab",
description: "Navi Mumbai Airport to Goa one way cab service provides economical transportation without return charges for passengers traveling to Goa. The service is ideal for travelers who require direct drop to Goa destinations. Vehicles provide comfortable seating and reliable highway performance. Professional drivers ensure safe driving and punctual airport pickups. Travelers enjoy flexible travel options and convenient booking. The cab provides comfortable AC interiors and smooth ride quality. Passengers benefit from affordable one-way travel."
},
{
name: "Navi Mumbai Airport to Goa Round Trip Taxi",
description: "Navi Mumbai Airport to Goa round trip taxi service provides convenient two-way transportation for travelers planning return journeys. The vehicle remains available for the entire travel schedule allowing flexible sightseeing in Goa. Comfortable seating and powerful AC ensure relaxed travel during long journeys. Professional drivers ensure safe driving and reliable service. Ideal for family holidays and group tours. Passengers enjoy convenient return travel planning. The service offers comfortable round-trip transportation."
},
{
name: "Goa Beach Trip Cab Navi Mumbai Airport",
description: "Goa beach trip cab from Navi Mumbai Airport provides comfortable transportation for travelers planning beach holidays in Goa. The cab service allows passengers to travel directly from the airport to Goa beaches and resorts. Vehicles provide spacious seating and smooth highway performance for long journeys. Professional drivers ensure safe driving and punctual pickups from airport terminals. Families and tourists enjoy comfortable AC travel throughout the trip. The service is perfect for holiday travelers and beach lovers. Passengers experience convenient and enjoyable travel to Goa."
}
],

tableData: [
["Navi Mumbai Airport to Goa Cab","Navi Mumbai Airport to Goa Taxi"],
["Cab from Navi Mumbai Airport to Goa","Taxi from Navi Mumbai Airport to Goa"],
["Navi Mumbai Airport Goa Cab Service","Navi Mumbai Airport Goa Taxi Service"],
["Navi Mumbai Airport to Goa Cab Booking","Navi Mumbai Airport to Goa Taxi Booking Online"],
["Navi Mumbai Airport to Goa Cab Price","Navi Mumbai Airport to Goa Taxi Fare"],
["Navi Mumbai Airport to Goa One Way Cab","Navi Mumbai Airport to Goa Round Trip Taxi"],
["Goa Beach Trip Cab Navi Mumbai Airport","Navi Mumbai Airport Goa Taxi"]
],


whychoose: [
  {
    WhyChooseheading: "Experienced Long-Distance Drivers",
    WhyChoosedescription: "Our drivers are highly experienced in long-distance highway travel from Navi Mumbai Airport to Goa. They are familiar with the Mumbai–Goa highway and Konkan routes, ensuring a safe and smooth journey."
  },
  {
    WhyChooseheading: "Transparent Cab Pricing",
    WhyChoosedescription: "Omshree Cabs provides transparent pricing for Navi Mumbai Airport to Goa cab bookings. Customers receive clear details about per-kilometer charges, toll costs, and driver allowance before confirming the booking."
  },
  {
    WhyChooseheading: "24/7 Airport Cab Availability",
    WhyChoosedescription: "Our Navi Mumbai Airport to Goa cab service operates 24 hours a day. Whether your flight arrives late at night or early morning, our drivers are available for reliable airport pickups."
  },
  {
    WhyChooseheading: "Clean & Comfortable AC Vehicles",
    WhyChoosedescription: "All vehicles in our fleet are fully air-conditioned, well maintained, and regularly sanitized to ensure a comfortable long-distance travel experience."
  },
  {
    WhyChooseheading: "Flexible One-Way & Round Trip Options",
    WhyChoosedescription: "We offer flexible travel options including one-way cab bookings, round trips, and multi-day travel packages from Navi Mumbai Airport to Goa."
  },
  {
    WhyChooseheading: "Multiple Vehicle Options",
    WhyChoosedescription: "Omshree Cabs offers a variety of vehicles including sedan cars, SUVs like Ertiga and Innova, premium vehicles like Innova Crysta, and Tempo Travellers suitable for families and group travelers."
  },
  {
    WhyChooseheading: "Direct Airport Pickup",
    WhyChoosedescription: "We provide convenient pickup directly from Navi Mumbai Airport terminals so travelers can start their Goa journey immediately without waiting for transport."
  },
  {
    WhyChooseheading: "Reliable Intercity Cab Service",
    WhyChoosedescription: "Omshree Cabs is trusted by many travelers for Navi Mumbai Airport to Goa cab bookings thanks to our punctual drivers, comfortable vehicles, and professional service."
  }
]
};

const faqData = [
  { question: "Do you provide cab service from Navi Mumbai Airport to Goa?", answer: "Yes, Omshree Cabs provides reliable cab services from Navi Mumbai Airport to Goa for both one-way and round-trip travel." },
  { question: "What is the distance from Navi Mumbai Airport to Goa?", answer: "The distance from Navi Mumbai Airport to Goa by road is approximately 560 km depending on the route." },
  { question: "How long does the journey take by cab?", answer: "The cab journey usually takes around 9 to 11 hours depending on traffic conditions and the chosen highway route." },
  { question: "Can I book a one-way cab from Navi Mumbai Airport to Goa?", answer: "Yes, we provide both one-way and round-trip cab services between Navi Mumbai Airport and Goa." },
  { question: "Which vehicles are available for this route?", answer: "We provide sedan cars, SUVs like Ertiga and Innova, premium vehicles like Innova Crysta, and Tempo Travellers depending on passenger requirements." },
  { question: "Is the cab service available 24 hours?", answer: "Yes, our airport cab service operates 24/7 so passengers can book anytime based on their flight arrival." },
  { question: "Are all vehicles air-conditioned?", answer: "Yes, all vehicles provided by Omshree Cabs are fully air-conditioned for comfortable long-distance travel." },
  { question: "Can we stop during the journey?", answer: "Yes, passengers can request stops during the journey for meals, refreshments, or scenic viewpoints." },
  { question: "Is advance booking recommended?", answer: "Yes, advance booking is recommended especially during weekends, holidays, and tourist seasons when Goa travel demand is high." },
  { question: "Are vehicles sanitized regularly?", answer: "Yes, all vehicles are cleaned and sanitized regularly to ensure passenger safety and hygiene." }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Amit Shah",
    feedback:
      "We booked Omshree Cabs from Navi Mumbai Airport to Goa. The driver was punctual and the long journey was very comfortable.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Kavita Desai",
    feedback:
      "Excellent airport cab service. Clean vehicle, professional driver, and smooth travel from Navi Mumbai Airport to Goa.",
    rating: 5
  }
];








































const Images = [
  { place: "/images/keyword/1.jpg", text: "Mumbai Outstation Cabs", link: "Mumbai-Outstation-Cab" },
{ place: "/images/keyword/2.jpeg", text: "Mumbai to Mahabaleshwar Cab", link: "Mumbai-to-Mahabaleshwar-Cab" },
{ place: "/images/keyword/3.jpg", text: "Mumbai to Goa Cabs", link: "Mumbai-to-Goa-Cabs" },
{ place: "/images/keyword/4.jpg", text: "Mumbai to Shirdi Cab", link: "Mumbai-to-Shirdi-Cab" },
{ place: "/images/keyword/5.jpeg", text: "Mumbai Nashik Cab", link: "Mumbai-Nashik-Cab" },
{ place: "/images/keyword/6.jpg", text: "Mumbai to Kolhapur Cab", link: "Mumbai-to-Kolhapur-Cab" },
{ place: "/images/keyword/7.jpeg", text: "Mumbai to Pune Cab", link: "Mumbai-to-Pune-Cab" },
{ place: "/images/keyword/8.jpg", text: "Mumbai to Aurangabad Cab", link: "Mumbai-to-Aurangabad-Cab" },
{ place: "/images/keyword/9.jpg", text: "Mumbai to Bhimashankar Cab", link: "Mumbai-to-Bhimashankar-Cab" },
{ place: "/images/keyword/10.jpg", text: "Mumbai to Ashtavinayak Cab Service", link: "Mumbai-to-Ashtavinayak-Cab-Service" },
{ place: "/images/keyword/11.jpeg", text: "Mumbai to 5 Jyotirlinga Cab", link: "Mumbai-to-5-Jyotirlinga-Cab" },
{ place: "/images/keyword/12.jpg", text: "Mumbai to Lonavala Cab", link: "Mumbai-to-Lonavala-Cab" },
{ place: "/images/keyword/13.jpg", text: "Mumbai to Konkan Darshan Cab Booking", link: "Mumbai-to-Konkan-Darshan-Cab-Booking" },
{ place: "/images/keyword/14.jpg", text: "Mumbai to Alibaug Cab", link: "Mumbai-to-Alibaug-Cab" },
{ place: "/images/keyword/15.jpg", text: "Mumbai to Ahmednagar Cab", link: "Mumbai-to-Ahmednagar-Cab" },
{ place: "/images/keyword/16.jpeg", text: "Mumbai to Matheran Cab", link: "Mumbai-to-Matheran-Cab" },
{ place: "/images/keyword/17.jpg", text: "Mumbai to Jalgaon Cab Booking / Dhule", link: "Mumbai-to-Jalgaon-Cab-Booking-Dhule" },
{ place: "/images/keyword/18.jpg", text: "Mumbai to Lavasa Cab", link: "Mumbai-to-Lavasa-Cab" },
{ place: "/images/keyword/19.jpg", text: "Mumbai to Panchgani Cab", link: "Mumbai-to-Panchgani-Cab" },
{ place: "/images/keyword/20.jpg", text: "Mumbai to Khandala Taxi Fare", link: "Mumbai-to-Khandala-Taxi-Fare" },
{ place: "/images/keyword/21.jpeg", text: "Mumbai to Surat Cab", link: "Mumbai-to-Surat-Cab" },
{ place: "/images/keyword/22.jpg", text: "Mumbai to Ahmedabad Cab", link: "Mumbai-to-Ahmedabad-Cab" },
];










const jsonData = {
  "@context": "https://schema.org",
  "@type": "LocalBusiness",
  "name": "Omshree Cab",
  "description": "Omshree Cab offers reliable cabs from Navi Mumbai Airport to Goa for one-way and round trips, including beach trips, family travel, and corporate journeys. Comfortable and well-maintained vehicles for long-distance travel.",
  "telephone": "+91 9892544084",
  "url": "https://www.omshreecab.com",
  "areaServed": {
    "@type": "City",
    "name": "Navi Mumbai, Maharashtra, India"
  },
  "serviceType": [
    "Navi Mumbai Airport to Goa Cab",
    "One Way Cab",
    "Round Trip Taxi",
    "Beach Trip Cab",
    "Family Cab",
    "Corporate Cab",
    "Long Distance Taxi",
    "Outstation Cab",
    "Luxury Cab"
  ]
};







  return (
    <div>
      
<Helmet>
  <title>Navi Mumbai Airport to Goa Cab Service | Omshree Cab</title>
  <meta
    name="description"
    content="Book a cab from Navi Mumbai Airport to Goa with Omshree Cab. Available for one-way trips, round trips, beach vacations, family travel, and corporate journeys. Comfortable, reliable, and affordable long-distance cab service."
  />
  <script type="application/ld+json">
    {JSON.stringify(jsonData)}
  </script>
</Helmet>


 <div className="breadcrumb-bar">
      <div className="container">
        <div className="row align-items-center text-center">
          <div className="col-md-12 col-12">
            <h2 className="breadcrumb-title"> {cardData.keyword}</h2>
           
          </div>
        </div>
      </div>
    </div>




      








      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/97.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Omshree Cabs: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                {/* <p className="sectionLead">{cardData.top}</p> */}
              
     <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                  
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>

              
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚙
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              {/* <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable /> */}

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Omshree Cab</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Omshree Cab </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
       <div className="pc-contact">
      <h4 className="pc-title">Contact Information</h4>

      <div className="pc-grid">
        {/* Phones */}
        <section className="pc-tile">
          <header className="pc-tile-head">
            <BsTelephoneFill className="pc-icon" />
            <span>Phone Numbers</span>
          </header>

          <div className="pc-list">
            <a href="tel:+919892544084" className="pc-call">
              +91 9892544084
            </a>
          </div>

          <div className="pc-cta">
            <a
              href="https://wa.me/919892544084"
              target="_blank"
              rel="noopener noreferrer"
              className="pc-whats"
            >
              <BsWhatsapp /> WhatsApp
            </a>

            <a href="tel:+919892544084" className="pc-primary">
              Call Now
            </a>
          </div>
        </section>

        {/* Email */}
        <section className="pc-tile">
          <header className="pc-tile-head">
            <BsEnvelopeFill className="pc-icon" />
            <span>Email</span>
          </header>

          <a href="mailto:booking@omshreecabs.com" className="pc-email">
            booking@omshreecabs.com
          </a>
        </section>

        {/* Address */}
        <section className="pc-tile">
          <header className="pc-tile-head">
            <BsGeoAltFill className="pc-icon" />
            <span>Address</span>
          </header>

          <address className="pc-address">
            <strong>Omshree Cab</strong>
            <br />
           Shri Omkar Co-op Housing Society,
            <br />
            E-11/101, Sector 9,
Ghansoli (Gharonda),
            <br />
            Navi Mumbai, Maharashtra, India - 400701
          </address>
        </section>
      </div>
    </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Navimumbaiairporttogoacab;